var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3804 2.58696L11.384 1.59194C11.2811 1.48913 11.1459 1.4375 11.0108 1.4375C10.8758 1.4375 10.7408 1.48883 10.6379 1.59165L9.84082 2.38644L11.5834 4.12594L12.3804 3.33144C12.5864 3.12567 12.5864 2.792 12.3804 2.58696Z",
    fill: "#9E9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 7.55044L6.4097 9.29023L11.2102 4.49858L9.46739 2.75879L4.66699 7.55044Z",
    fill: "#9E9D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29111 7.92285L3.91895 10.0332L6.03382 9.66235L4.29111 7.92285Z",
    fill: "#9E9D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10801 10.9736H2.53719V4.40277H7.1744L8.3173 3.26221H2.13426C1.7284 3.26221 1.39648 3.59412 1.39648 3.99998V11.3767C1.39648 11.7825 1.7284 12.1143 2.13426 12.1143H9.51094C9.91665 12.1143 10.2486 11.7825 10.2486 11.3767V6.1026L9.10801 7.24112V10.9736Z",
    fill: "#9E9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.e15503651eb30da8b8e3faaef1cb2f61.svg";
export { ForwardRef as ReactComponent };